function isPlainObject(obj: any): boolean {
    return Object.prototype.toString.call(obj) === '[object Object]';
}

// ----------------------------------------------------------------------------

export default isPlainObject;
